import { gql, useMutation } from "@apollo/client";
import { InputField } from "@src/components/fields";
import Form from "@src/components/Form";
import {
    type GQLCreateCameraFirmwareAdminMutation,
    type GQLCreateCameraFirmwareAdminMutationVariables,
    type GQLCreateCameraFirmwareInput,
} from "@src/graphql.generated";
import { type FC, type PropsWithChildren } from "react";
import { useIntl } from "react-intl";

const createCameraFirmwareMutation = gql`
    mutation CreateCameraFirmwareAdmin($input: CreateCameraFirmwareInput!) {
        createCameraFirmwareAdmin(input: $input) {
            id
        }
    }
`;

const AddForm: FC<PropsWithChildren> = () => {
    const intl = useIntl();
    const [createMutation] = useMutation<GQLCreateCameraFirmwareAdminMutation, GQLCreateCameraFirmwareAdminMutationVariables>(
        createCameraFirmwareMutation,
    );

    const submit = ({ name }: GQLCreateCameraFirmwareInput) => {
        return createMutation({
            variables: {
                input: {
                    name: name.trim(),
                },
            },
        });
    };

    return (
        <Form
            mode="add"
            onSubmit={submit}
            title={intl.formatMessage({ id: "reviermanager.firmware.form.add.title", defaultMessage: "Neue Firmware hinzufügen" })}
        >
            <InputField name="name" label={intl.formatMessage({ id: "reviermanager.camera.name", defaultMessage: "Name" })} />
        </Form>
    );
};

export default AddForm;
